<script>
export default {
  props: {
    onFaultMonitorAlertClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
